import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { PERMISSIONS, ROLES } from '@/lib/auth/roles'
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import ArticlesTable from '@/modules/articles/articles-table'
import {
  articlesQueryOptions,
} from '@/modules/articles/articles-table/hooks'
import {
  ArticlesSearch, defaultFetchParamsArticles, mergedArticlesSchema,
} from "@/types/route-search-schemas";
import { DataLoader } from '@/types/router-context'
import {ARTICLES_PATH, ARTICLES_URL} from "@/utils/urls";

export const Route = createFileRoute(ARTICLES_PATH)({
  component: Articles,
  validateSearch: (search: Record<string, unknown>): ArticlesSearch => validateSearchWithDefaults(mergedArticlesSchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(ARTICLES_URL)) {
      return
    }

    return queryClient.prefetchQuery(articlesQueryOptions(defaultFetchParamsArticles))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Reputation', path: '#' },
        { label: 'Articles', path: ARTICLES_URL },
      ],
      children: null
    }
  },
})

function Articles() {

  return (
    <Authorisation
      roles={[ROLES.ROLE_EDIT_FIRM, ROLES.ROLE_VIEW_FIRM]}
      permissions={[PERMISSIONS.IS_FULL_FIRM_OR_NETWORK_VIEW, PERMISSIONS.CAN_ACCESS_ARTICLES]}
      forbiddenFallback={<Unauthorized />}
    >
      <div className={'flex flex-col items-center justify-center'}>
        <ArticlesTable />
      </div>
    </Authorisation>
  )
}
